import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { shift_pressed } from '../../keypress';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import linear_svg from '../../../assets/img/SVG_icons/Top/editing_model/make_edge_linear.svg';
import { img } from '@phi/components';
import { uid_set_linearity_of_selected_edges } from '@frontend/ui_display';
import LinearTooltip from './LinearTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const LinearIcon = linear_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Make edge linear';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || this.state.selected_edges_count === 0;
        },

        every_edge_is_linear() {
            this.state.selected_edges_count;
            if (!uid_selected_edges) return false;
            else return uid_selected_edges.values().every(x => x.get_linearity_flag());
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.every_edge_is_linear)
                uid_set_linearity_of_selected_edges(false);
            else
                uid_set_linearity_of_selected_edges(true && !shift_pressed());
        }
    },

    render() {
        return h(BarButton, {
            id: 'make-edge-linear-button',
            wrapperId: 'make-edge-linear-wrapper',
            onClick: this.onClick,
            disabled: this.disabled,
            active: this.every_edge_is_linear,
            selected: this.state.tut_stage === 7,
            tippy: 'left',
            help: 'make_edge_linear',
        }, {
            label: () => 'Linear',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(linear_svg, this.alt),
            tooltip: LinearTooltip,
        });
    },
});
